import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components

import styles from "../ServicesSections.module.scss";

export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={8} md={8}>
          <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>
            Why choose us for your data & analytics services?
          </h3>

          <p>
           We are an analytics agency that is different from the rest. With us you will get absolute quality, 
           unsurpassed experience and non-negotiable independence.
           <br/>
           <br/>
           <strong>Quality: </strong> Our motto is "We help you understand your business better". Therefore we aim to be the 
           experts in all areas of data & analytics. We are not just there to tick a box, get paid and move on.
           We are there to make your business better. To work with you, to fill in the gaps, to take up the slack where you need resources, 
           to save you time and simply to do a good job. 
           <br/>
           <br/>
           To meet that criteria we have the best people in the industry working for our business. We love doing a good job! 😀
           <br/>
           <br/>
           <strong>Experience: </strong> Our staff have degrees in mathematics, IT and marketing. Not only that, we have a PhD in astrophysics! 
           Our staff have taught university level maths and engineering courses in our academic years. Over the last 6 years we have taught Google Analytics, GA4, 
           BigQuery, Google Cloud Platform and Google Tag Manager courses all over Australia - and even Indonesia where we taught Tokopedia, 
           (Indonesia's Ebay), the largest Ecommerce company in Indonesia how to use dataflow and related tools on Google Cloud Platform. 
           <br/>
           <br/>
           </p>
           <img
                  src="/img/services/images/scott-tokopedia-indonesia-2017.JPG"
                  alt="..."
                  className={imgClasses}
                />
                 <br/>
                 <br/>
                 <GridContainer justifyContent="center">
                <i>
                  Scott teaching dataflow and related tools to Tokopedia in 2017.
                  
                </i>
                </GridContainer>
                <br/>
                 
                <p>

           <strong>Independence: </strong> 

           Many large organisations struggle to compete with the <strong>nimbleness</strong> and <strong>innovation</strong> of 
           organisations like ours - so they buy smaller companies up. Check if your provider is actually part of a larger group.

           It is usually accompanied by a loss of performance.
           <br />
            <br />
            Many providers are also tied to a particular platform, like Google or Adobe. We are <strong>independent</strong>. 
            We are a reseller
            of nothing. We work with everything. We are here to give you the best independent advice and work with whatever tools are necessary to 
            achieve your goals!
            <br />
            <br />
            If any tool or approach is not in your interests, we will not recommend it!
          </p>



        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>
            Some examples of our work
          </h3>
          </GridItem>

        <GridItem
          xs={12}
          sm={10}
          md={10}
          className={classes.section}
          style={{ paddingTop: "10px" }}
        >
          <GridContainer>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/analytics-services/GA-4-small.webp"
                alt="..."
                className={imgClasses}
              />
              <div style={{ textAlign: "center" }}>
                <i>
                  <br />
                  Google Analytics 4 (GA4)
                </i>
              </div>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/analytics-services/data-studio-small.webp"
                alt="..."
                className={imgClasses}
              />
              <div style={{ textAlign: "center" }}>
                <i>
                  <br />
                  Reports in Data (Looker) Studio
                </i>
              </div>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/analytics-services/bigquery-small.webp"
                alt="..."
                className={imgClasses}
              />
              <div style={{ textAlign: "center" }}>
                <i>
                  <br />
                  BigQuery with Structures
                </i>
              </div>
            </GridItem>
          </GridContainer>
        </GridItem>
        <GridItem xs={12} sm={8} md={8}>
          <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>
            What tools do we specialise in?
          </h3>

          <p>
           We are tool agnostic. We'll work with any tool to get the job done!
           <br />
           <br />
           That said we have years of experience in the following:
           </p>
           
           <ul>
            <li><strong>Google Analytics/GA4:</strong> We have been teaching courses all over Australia for since 2016. In recent
            years we have been very busy teaching GA4 courses offsite at businesses and at our in-house sessions. Fore more 
            info see <a href="/services/training/google-analytics-training">here.</a>  </li>
            <li><strong>Google Tag Manager:</strong> We manage some of the most complex GTM setups in Australia, including huge
            retail websites. We also manage containers across multinational domains with all the complications that entails. Like 
            GA4 we also train others on how to use GTM, see <a href="/services/training/google-tag-manager-training">here</a> for more.  </li>
            <li><strong>BigQuery:</strong> In order to get your GA4 setups really humming, you need to use the free google bigquery
           connection. BigQuery is the bedrock for some of our advanced reporting in Streamlit, Looker Studio and D3.observable.
           Like GA4 and GTM we teach courses on BigQuery and related tools in GCP. See <a href="/services/training/google-bigquery-training">here</a> and 
           <a href="/services/training/google-cloud-platform-training"> here</a> for more. </li>
           <li><strong>Streamlit:</strong> Over the last couple of years we have moved beyond the limits of Looker Studio and developed 
           brilliant automated reporting in Streamlit - connected to BigQuery and related systems. Streamlit allows for professional
            BI like reporting and dashboards, as well as data-science level statistical modelling for detailed analysis.
             For more on our work in streamlit, see <a href="/our-work/streamlit-and-business-performance">here</a>, 
           <a href="/our-work/streamlit-and-google-analytics-data"> here</a> and <a href="/blog-post/2024/01/using-streamlit-to-build-web-applications"> here</a>! </li>
           <li><strong>D3/Observable:</strong> This is our new favourite tool. Over the last year we have built some epic reports using 
           this super functional and super customisable dashboarding and reporting tool used by the likes of Chat GPT and others! 
           This is for serious analysis when the likes of looker studio or even tableau wont cut it! For more info see <a href="/">here</a>.
            </li>
           </ul>

           </GridItem>
        
      </GridContainer>
    </div>
  );
}
